module.exports = __webpack_public_path__ + "static/media/shuffle-icon.f8863b8d.svg";